/**
 * @fileoverview A function that changes the password of the user.
 *
 * @example
 * changePassword()
 */

/**
 * @function changePassword
 * @description This function is used to change the password of the user
 */
export function changePassword() {
    window.location.href = '/password/change'
}
